import LazyLoad from 'vanilla-lazyload';

export function initLazyLoad() {
    // eslint-disable-next-line no-unused-vars
    const lazyLoadInstance = new LazyLoad();
}
